import { render, staticRenderFns } from "./PdpTextCopyTab.vue?vue&type=template&id=58c4e642&scoped=true"
import script from "./PdpTextCopyTab.vue?vue&type=script&lang=js"
export * from "./PdpTextCopyTab.vue?vue&type=script&lang=js"
import style0 from "./PdpTextCopyTab.vue?vue&type=style&index=0&id=58c4e642&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c4e642",
  null
  
)

export default component.exports